import * as angular from 'angular';
import * as _ from 'lodash';

import { IAccountService, IUserService, ILoggerService, IAuthenticationService } from '../../services';
import { ComponentDefinition, IUserModel } from '../../models';

class UserChangePasswordController implements angular.IComponentController {

    user: IUserModel;
    userName: string;
    userId: string;
    userGuid: string;
    isLoading: boolean;
    isInEditingMode: boolean;
    control: any;
    password: string = '';
    passwordNew: string = '';
    passwordReNew: string = '';
    messageCurrentPassword: string = '';

    static $inject = [
        '$stateParams',
        '$translate',
        'accountService',
        'userService',
        'loggerService',
        'authenticationService'
    ];

    constructor(
        private _$stateParams: angular.ui.IStateParamsService,
        private _$translate: angular.translate.ITranslateService,
        private _accountService: IAccountService,
        private _userService: IUserService,
        private _loggerService: ILoggerService,
        private _authenticationService: IAuthenticationService) {
    }

    $onInit() {
        this.isInEditingMode = false;
        this.control = {
            canEdit: this.innerCanEdit(),
            edit: this.innerEdit(),
            canSave: this.innerCanSave(),
            save: this.innerSave(),
            canCancel: this.innerCanCancel(),
            cancel: this.innerCancel(),
            errors: []
        };

        /** If userName is empty, get it from state params */
        if (!this.user && this.userName === undefined) {
            this.userName = this._$stateParams.userName;
        }

        /** If userName is empty, get it from authetification */
        if (!this.user && this.userName === undefined) {
            this.userName = this._authenticationService.authentication.userName;
        }

        /** If userId is empty, get it from authetification */
        if (!this.user && this.userId === undefined) {
            this.userId = this._authenticationService.authentication.userId;
        }

        /** If userId is empty, get it from authetification */
        if (!this.user && this.userGuid === undefined) {
            this.userGuid = this._authenticationService.authentication.userGuid;
        }

        /** If user & userName are set, get user data */
        if (this.user && this.userName) {
            this.isLoading = true;
            this._userService
                .getUserModelByUserName(this.userName)
                .then(data => {
                    this.user = data;
                    this.isLoading = false;
                });
        }
    }

    innerCanEdit(): () => boolean {
        return () => {
            const isNotDomainUser = !this.user || !this.user.domainName;
            return !this.isInEditingMode && !this.isLoading && isNotDomainUser;
        };
    }

    innerEdit(): () => void {
        return () => {
            this.isInEditingMode = true;
        };
    }

    innerCanSave(): () => boolean {
        return () => {
            return this.isInEditingMode
                && !this.isLoading
                && this.passwordReNew === this.passwordNew;
        };
    }

    innerSave(): () => void {
        return () => {
            return this._accountService.updatePasswordSafely(this.password, this.passwordNew)
                .then(data => {
                    if (data && data.length && data.length > 0) {
                        if (_.every(data, d => d.isValid)) {
                            const msg = this._$translate.instant('Password changed successfully.');
                            this._loggerService.logSuccess(msg);
                            this.innerCancel()();
                            return true;
                        } else {
                            const messages = [];
                            data.forEach(d => {
                                if (!d.isValid) {
                                    this._loggerService.logError(this._$translate.instant(d.message));
                                    messages.push(d.message);
                                }
                            });
                            this.control.errors = messages;
                        }
                    } else {
                        const message = 'Error in API request for changing password.';
                        this._loggerService.logError(this._$translate.instant(message));
                        this.control.errors = [message];
                    }
                })
                .catch(e => {
                    this.control.errors = [e.data.Message];
                });
        };
    }

    innerCanCancel(): () => boolean {
        return () => {
            return this.isInEditingMode
                && !this.isLoading;
        };
    }

    innerCancel(): () => void {
        return () => {
            this.password = '';
            this.passwordNew = '';
            this.passwordReNew = '';
            this.messageCurrentPassword = '';
            this.control.errors = '';
            this.isInEditingMode = false;
        };
    }

    getMessagePasswordCurrent(): string {
        return undefined;
    }

    getMessagePasswordsMatch(): string {
        let result: string;

        if (this.passwordReNew.length === 0) {
            result = '';
        } else if (this.passwordReNew.length < this.passwordNew.length) {
            result = this._$translate.instant('Match password too short');
        } else if (this.passwordReNew === this.passwordNew) {
            result = this._$translate.instant('Passwords match');
        } else {
            result = this._$translate.instant('Passwords do not match');
        }

        return result;
    }
}

export const wtUserChangePassword: ComponentDefinition = {
    componentId: 'wtUserChangePassword',
    controller: UserChangePasswordController,
    template: require('./userChangePassword.component.html'),
    controllerAs: 'vm',
    bindings: {
        control: '=',
        user: '=?',
        userName: '<?'
    }
};
